<template >
    <div class="page-header align-items-start min-vh-100 position-relative login-background">
        <span class="mask bg-gradient-light opacity-7"></span>
        <div class="container my-auto">
            <div class="row">
                <div class="col-lg-8 col-md-12 col-12 mx-auto">
                    <div class="card z-index-0 fadeIn3 fadeInBottom">                        
                        <div class="card-body">
                            <div class="text-center">
                                <img src="../../assets/img/Veeboek-logo.png" class="logo mb-2" alt="Vee Boek">
                            </div>
                            <div class="text-start mt-3">
                                <div class="text-center">
                                    <h3 class="text-green">{{ $t('signup.Sign_up') }}</h3>
                                </div>
                                <form @submit.prevent="signUp" id="signUpForm">
                                    <div class="mb-3">
                                        <label class="form-label">{{ $t('signup.User_name') }} *</label>
                                        <input type="text" class="input" v-model.trim="userName">
                                        <span class="error-message text-danger" v-if="!userName && attemptedSignUp">{{ $t('signup.Username_is_required') }}</span>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <label class="form-label">{{ $t('signup.Password') }} *</label>
                                            <input :type="showPassword ? 'text' : 'password'" class="input w-100" v-model.trim="password" id="password">                                            
                                            <span class="error-message text-danger" v-if="!password && attemptedSignUp">{{ $t('signup.Password_is_required') }}</span>
                                        </div>

                                        <div class="col-md-6 mb-3">
                                            <label class="form-label">{{ $t('signup.Confirm_password') }} *</label>
                                            <input :type="showPassword ? 'text' : 'password'" class="input w-100" v-model.trim="confirmPassword" id="confirmPassword">  
                                            <span class="error-message text-danger" v-if="confirmPassword && confirmPassword !== password && attemptedSignUp">
                                                {{ $t('signup.Confirm_password_mismatch') }}
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <label class="form-label">{{ $t('signup.First_name') }} *</label>
                                            <input type="text" class="input w-100" v-model.trim="firstName">
                                            <span class="error-message text-danger" v-if="!firstName && attemptedSignUp">{{ $t('signup.First_name_is_required') }}</span>
                                        </div>

                                        <div class="col-md-6 mb-3">
                                            <label class="form-label">{{ $t('signup.Last_name') }} *</label>
                                            <input type="text" class="input w-100" v-model.trim="lastName">
                                            <span class="error-message text-danger" v-if="!lastName && attemptedSignUp">{{ $t('signup.Last_name_is_required') }}</span>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-md-6 mb-3">
                                            <label class="form-label">{{ $t('signup.Mobile_number') }} *</label>
                                            <input type="text" class="input" v-model.trim="mobileNumber">
                                            <span class="error-message text-danger" v-if="!mobileNumber && attemptedSignUp">{{ $t('signup.Mobile_number_is_required') }}</span>
                                        </div>
                                    </div>
                                    
                                    <div class="text-center">
                                        <error v-if="error" :error="error" class="mb-2" />
                                        <button type="submit" class="btn bg-gradient-success btn-md w-100 my-3">{{ $t('signup.Sign_up') }}</button>
                                    </div>                                    
                                </form>  
                                <div class="text-center">                                        
                                    <hr>                                                               
                                    <router-link to="/login" class="btn bg-gradient-light btn-md" style="display: inline-flex; align-items: center; justify-content: center;">
                                        <span class="material-symbols-outlined" style="font-size: 16px; margin-right: 2px;">arrow_circle_left</span> 
                                        {{ $t('signup.Back_login_page') }}
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <auth-footer />
    </div>
</template>
  
<script>
import axios from 'axios'
import Error from '../../components/GlobalAlert.vue'
import AuthFooter from './Footer.vue';
import { mapMutations } from "vuex";

export default {
    name: "Sign_Up",
    components: {
        Error,
        AuthFooter
    },
    data()
        {
            return {
                userName:'',
                password:'',
                confirmPassword:'',
                firstName:'',
                lastName:'',
                mobileNumber:'',
                showPassword: false,
                attemptedSignUp: false,
                deviceType:'',                
                userHostName:'',
                userHostIp:'',
                computerName:'',
                posts: [],
                error: ''
            }
        },    
    mounted() {
    },    
    methods: {
        ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
        togglePassword() {
            this.showPassword = !this.showPassword;
        },        
        async signUp() {    
                try {
                    this.attemptedSignUp = true;
                    if (!this.userName || !this.password || !this.confirmPassword || !this.firstName || !this.lastName || !this.mobileNumber) {
                        alert('here');
                        return;
                    }

                    this.$store.commit('setShowLoading', true);   
                                   
                    const response = await axios.post("Auth/signup", { 
                            userName: this.userName,
                            password : this.password,
                            firstName : this.firstName,
                            lastName : navigator.lastName,
                            mobileNumber : this.mobileNumber 
                        });
                                                
                    this.posts = response.data;
                    //alert(this.posts.success);
                    //alert(this.posts.token);
                    //alert(this.posts.message);
                    //alert(this.posts.user);

                    if(this.posts.success) {
                        //localStorage.setItem('sheepbase-token', this.posts.token);                                                
                        this.$store.commit('setShowNavbar', true); 
                        //this.$store.dispatch('user', this.posts.user);  
                        this.$store.commit('user', this.posts.user);

                        axios.defaults.headers.common['Authorization'] = 'bearer ' + this.posts.token;
                        axios.defaults.headers.common['Authorization'] = 'bearer ' + this.posts.token;
                        axios.defaults.headers.get['Authorization'] = 'bearer ' + this.posts.token;
                        axios.defaults.headers.post['Authorization'] = 'bearer ' + this.posts.token;
                        axios.defaults.headers.delete['Authorization'] = 'bearer ' + this.posts.token;
                        
                        this.$router.push('/');                        
                    } else{                        
                        this.error = 'Invalid username/password';
                    }
                } catch (e) {
                    this.error = 'Invalid username/password';
                }
                this.$store.commit('setShowLoading', false); 
            }
    },
};
</script>
<style src="@/assets/css/auth.css"></style>
  